import AccordionItem from "./accordion-item/accordion-item";
import style from './accordion.module.scss'

const accordionItems = [
    {
        id: 1,
        title: "Cross-platform development",
        text: [
            {
                id: 1,
                text: "Our cryptocurrency app development project is based on a cross-platform approach, which is a more cost-efficient solution since the application works on any OS platform. But the coin has a downside."
            },
            {
                id: 2,
                text: "Above all, the developer must not only understand the technology stack used but also have some knowledge of the operation of iOS and Android platforms. In addition, he should be able, if necessary, to create certain modules in their respective languages."
            },
            {
                id: 3,
                text: "We did it with a bang and developed a high-performance application that works quickly and efficiently."
            },
        ]
    },
    {
        id: 2,
        title: "Working with multiple cryptocurrencies",
        text: [
            {
                id: 1,
                text: "The second challenge of the project was that it included multiple cryptocurrencies. Therefore, we had to unify the process of interaction with them."
            },
            {
                id: 2,
                text: "We also needed to provide a basis for future application scaling so that one could add new currencies with minimal effort."
            },
        ]
    },
    {
        id: 3,
        title: "Interaction with blockchain",
        text: [
            {
                id: 1,
                text: "We didn't bring up our own nodes and interacted with blockchains through electrum servers. Since these servers only support the TCP protocol, we needed to create an additional proxy service to convert HTTP to TCP."
            },
            {
                id: 2,
                text: "Primarily, this microservice is responsible for decoding transactions. In addition, it monitors the status of electrum servers to provide smooth interaction with the blockchain."
            },
        ]
    },
    {
        id: 4,
        title: "The complexity of market data processing",
        text: [
            {
                id: 1,
                text: "Another challenge of our project was the aggregation and processing of cryptocurrency market data and its further transfer to the user. We had to find a way to render all the charts without reducing the application performance."
            },
            {
                id: 2,
                text: "And our team did an excellent job with this task."
            },
        ]
    },
    {
        id: 5,
        title: "Securing the Wallex app",
        text: [
            {
                id: 1,
                text: "Any financial application must be well-protected to ensure the security of money transactions. And the Wallex app is no exception."
            },
            {
                id: 2,
                text: "To maximize the app protection, we've used the most modern encryption methods. Also, we ensured that information about private keys remained inaccessible to the server, which additionally secured the crypto-wallet."
            },
        ]
    },
    {
        id: 6,
        title: "Release of the new 14 iOS",
        text: [
            {
                id: 1,
                text: "Also, work on the project was complicated by the fact that it coincided with the release of iOS 14 and the update of the NativeScript framework to the 7th version. Consequently, our experts had to consider new and so far little-known system requirements during the cryptocurrency app development process."
            },
        ]
    },
]

const Accordion = () => {
    return (
        <div className={style.accordion}>
            <hr />
            {
                accordionItems.map((item: any) => {
                    return (
                            <div key={item.id}>
                                <AccordionItem state={item} />
                                <hr />
                            </div>
                    )
                })
            }

        </div>
    )
}

export default Accordion;
